// 전체화면 창 시스템의 z 사다리 — c6 오버레이 밴드 사이에 끼운다(단일 소스, 소비처는 inline style 로
// 지정한다). inline 인 이유: c6 modalStack 의 inert 판정(effectiveZ)이 body 직속 자식의 computed
// z-index 를 읽으므로, 시각 z 와 판정 z 가 같은 값에서 나와야 하고 CSS 파일과 이중화되면 어긋난다.
//
//   창 오버레이(880) < 작업표시줄(890) < c6 tooltip 밴드(900) < c6 Modal 밴드(1000~)
//
// - 창(880): 창 스택이 그리는 전체화면 창. c6 Modal 밴드보다 낮춰 중첩 c6 Modal(확인 · 접수 모달)이
//   위에 쌓이고, tooltip 밴드보다 낮춰 호버 툴팁이 오버레이 위로 뜬다.
// - 작업표시줄(890): 활성 **창** 위에서 항상 상호작용 가능해야 한다(창 전환·최소화·닫기). 창이
//   modalStack 에 등록돼도 z 가 높은 body 직속 비-Modal 오버레이는 inert 대상에서 제외된다.
export const FULLSCREEN_WINDOW_Z = 880;
export const WINDOW_TASKBAR_Z = 890;
